export const DEFAULT_NPS = 'default_nps';

export const SCHEDULED_KIND = {
  SPECIFIC: 'specific_time',
  END: 'event_end',
  TEN_MINS: 'ten_mins_before_event_end',
  MIDDLE: 'event_middle',
};
